import { createContext, type Dispatch, type SetStateAction, useContext } from 'react';

import invariant from 'tiny-invariant';

type onExpansionToggle = (isExpanded: boolean) => void;

export const IsExpandedContext = createContext<boolean | null>(null);
export const SetIsExpandedContext = createContext<Dispatch<SetStateAction<boolean>> | null>(null);
export const IsChildSelected = createContext<boolean | null>(null);
export const OnExpansionToggleContext = createContext<onExpansionToggle | null>(null);
export const LevelContext = createContext(0);

export const useIsExpanded = (): boolean => {
	const context = useContext(IsExpandedContext);
	invariant(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
	return context;
};

export const useSetIsExpanded = (): Dispatch<SetStateAction<boolean>> => {
	const context = useContext(SetIsExpandedContext);
	invariant(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
	return context;
};

export const useIsChildSelected = (): boolean => {
	const context = useContext(IsChildSelected);
	invariant(context !== null, 'useIsChildSelected must be used within an ExpandableMenuItem');
	return context;
};

export const useOnExpansionToggle = (): onExpansionToggle | null =>
	useContext(OnExpansionToggleContext);

export const useLevel = (): number => useContext(LevelContext);
